// extracted by mini-css-extract-plugin
export default {"number":"CardNumber_number__VTM65"};